import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Paper, Typography, Button, Checkbox, FormControlLabel, Box, useMediaQuery } from '@mui/material';
import Navbar from '../../components/Features/Navbar';
import Footer from '../../components/Home/Footer';

const ContratSuiviExpert = () => {
    const navigate = useNavigate();
    const [acceptedContract, setAcceptedContract] = useState(false);
    const [showPayment, setShowPayment] = useState(false);

    useEffect(() => {
        document.title = 'Contrat Forfait Expert | Tsahal Connection';
    }, []);

    const handleValidateContract = () => {
        if (acceptedContract) {
            // Afficher la page de paiement intégrée
            setShowPayment(true);
        } else {
            alert("Vous devez accepter les termes du contrat pour continuer.");
        }
    };

    if (showPayment) {
        return (
            <div>
                <Navbar />
                <Container maxWidth="lg" style={{ marginTop: '2rem', marginBottom: '4rem' }}>
                    <Paper elevation={3} style={{ padding: '2rem', marginTop: '2rem' }}>
                        <Typography variant="h3" align="center" gutterBottom style={{ fontFamily: 'Montserrat', fontWeight: '700', color: '#2593C4', marginBottom: '2rem' }}>
                            Finaliser votre Inscription
                        </Typography>
                        <Typography variant="h6" align="center" gutterBottom style={{ fontFamily: 'Montserrat', marginBottom: '2rem' }}>
                            Forfait Expert - 2000₪ TTC
                        </Typography>
                        <iframe
                            src="https://mrng.to/XbgysAYXQt"
                            width="100%"
                            height="800"
                            style={{ border: '1px solid #ddd', borderRadius: '8px' }}
                            title="Paiement Morning"
                        />
                        <Box style={{ textAlign: 'center', marginTop: '2rem' }}>
                            <Button
                                variant="outlined"
                                size="large"
                                onClick={() => setShowPayment(false)}
                                style={{
                                    borderColor: '#2593C4',
                                    color: '#2593C4',
                                    padding: '1rem 3rem',
                                    fontSize: '1.1rem',
                                    fontFamily: 'Montserrat',
                                    fontWeight: '600'
                                }}
                            >
                                Retour au Contrat
                            </Button>
                        </Box>
                    </Paper>
                </Container>
                <Footer />
            </div>
        );
    }

    return (
        <div>
            <Navbar />
            <Container maxWidth="lg" style={{ marginTop: '2rem', marginBottom: '4rem' }}>
                <Paper elevation={3} style={{ padding: '2rem', marginTop: '2rem' }}>
                    <Typography variant="h3" align="center" gutterBottom style={{ fontFamily: 'Montserrat', fontWeight: '700', color: '#2593C4', marginBottom: '2rem' }}>
                        Contrat de Forfait Expert
                    </Typography>

                    <Paper elevation={1} style={{ marginBottom: '2rem', padding: '2rem', border: '1px solid #ddd' }}>
                        <Typography variant="h6" gutterBottom style={{ fontFamily: 'Montserrat', fontWeight: '600', color: '#2593C4', marginBottom: '1.5rem' }}>
                            Contrat de Service - Forfait Expert
                        </Typography>
                        
                        <Box style={{ fontFamily: 'Montserrat', lineHeight: '1.7', fontSize: '0.95rem' }}>
                            
                            <Typography paragraph style={{ fontSize: '1.1rem', fontWeight: 'bold', color: '#2593C4', marginBottom: '1rem' }}>
                                🧭 Forfait Expert Olim avec parents
                            </Typography>
                            
                            <Typography paragraph style={{ marginBottom: '1.5rem' }}>
                                <strong>Expert Connection – Tsahal Connection</strong><br/>
                                Accompagnement approfondi et individualisé destiné aux candidats à Tsahal, avec implication active de la famille, visant à construire une stratégie militaire complète, depuis l'orientation initiale jusqu'à l'entrée effective à l'armée.
                            </Typography>

                            <Typography paragraph style={{ backgroundColor: '#fff3cd', padding: '0.8rem', borderRadius: '6px', borderLeft: '4px solid #ffc107', marginBottom: '1.5rem' }}>
                                <strong>ℹ️ Mention importante</strong><br/>
                                Par souci de lisibilité, le présent texte est rédigé au masculin, mais il s'adresse bien entendu à toutes et à tous, sans distinction de genre.
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#2593C4', marginTop: '2rem', marginBottom: '1rem' }}>
                                ✅ Ce qui est inclus dans l'accompagnement
                            </Typography>

                            <Typography paragraph style={{ fontWeight: 'bold', marginBottom: '0.8rem' }}>
                                🔹 Préparation militaire
                            </Typography>

                            <Typography paragraph style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                <strong>Préparation au Tsav Rishon</strong><br/>
                                (2 rendez-vous de préparation – 1h chacun)
                            </Typography>

                            <Typography paragraph style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                <strong>Préparation au Yom Hamea</strong><br/>
                                (2 rendez-vous de préparation – 1h chacun)<br/>
                                <em>si le candidat ne passe pas le Yom Hamea :</em><br/>
                                → rendez-vous d'orientation sur les postes militaires à la place
                            </Typography>

                            <Typography paragraph style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                <strong>Rendez-vous "Cheelon Haadafot" (questionnaire de préférences)</strong><br/>
                                (1 rendez-vous – 45 minutes)<br/>
                                <em>si le candidat ne passe pas cette étape :</em><br/>
                                → rendez-vous d'orientation sur les classes militaires
                            </Typography>

                            <Typography paragraph style={{ marginLeft: '1rem', marginBottom: '1.5rem' }}>
                                <strong>Rendez-vous Mehinot / parcours d'études</strong><br/>
                                (1 rendez-vous – 45 minutes)<br/>
                                <em>si le candidat ne prévoit pas de mehinah ou d'études :</em><br/>
                                → rendez-vous d'orientation sur : les salaires pendant le service, les miyounim possibles en cours de service, les équipements et achats recommandés avant le giyus.
                            </Typography>

                            <Typography paragraph style={{ fontWeight: 'bold', marginBottom: '0.8rem' }}>
                                🔹 Suivi individuel, administratif & accompagnement continu
                            </Typography>

                            <Typography paragraph style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                <strong>1 entretien d'orientation stratégique personnalisé</strong><br/>
                                (45 minutes)<br/>
                                • analyse du profil du candidat<br/>
                                • définition d'une stratégie militaire cohérente<br/>
                                • prise en compte du contexte familial
                            </Typography>

                            <Typography paragraph style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                <strong>Aide administrative :</strong><br/>
                                • explication et aide au remplissage des formulaires militaires<br/>
                                • accompagnement dans les démarches liées aux différentes échéances de Tsahal
                            </Typography>

                            <Typography paragraph style={{ marginLeft: '1rem', marginBottom: '1rem' }}>
                                <strong>Accompagnement continu via WhatsApp (et téléphone si nécessaire) :</strong><br/>
                                • candidat et parents<br/>
                                • questions militaires, administratives et organisationnelles<br/>
                                • disponibilité tout au long du processus jusqu'à l'entrée à l'armée<br/>
                                <em>(valeur estimée du suivi continu via whatsapp : 1 000 ₪)</em>
                            </Typography>

                            <Typography paragraph style={{ marginLeft: '1rem', marginBottom: '1.5rem' }}>
                                <strong>Mise en relation avec d'anciens ou actuels soldats francophones</strong><br/>
                                (selon disponibilité et cohérence avec le projet du candidat)
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#dc3545', marginTop: '2rem', marginBottom: '1rem' }}>
                                ❌ Ce qui n'est pas garanti
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1rem' }}>
                                • L'obtention d'un poste précis.<br/>
                                • Un profil médical ou psychotechnique spécifique.<br/>
                                • L'acceptation de la candidature par Tsahal.
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1.5rem' }}>
                                Les décisions finales relèvent exclusivement de Tsahal, selon ses critères propres.<br/>
                                L'accompagnement proposé repose sur une obligation de moyens, et non de résultat.<br/>
                                À titre indicatif, la grande majorité des candidats qui suivent sérieusement les recommandations données intègrent l'armée, sans que cela ne constitue une garantie individuelle ou contractuelle.
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#2593C4', marginTop: '2rem', marginBottom: '1rem' }}>
                                📝 Engagements du candidat
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1rem' }}>
                                Le candidat s'engage à remplir le formulaire de contact et d'inscription disponible sur le site de Tsahal Connection, condition nécessaire au démarrage et au suivi de l'accompagnement.
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1.5rem' }}>
                                L'équipe Expert Connection reste disponible et joignable tout au long du processus.<br/>
                                Toutefois, il appartient au candidat de :<br/>
                                • nous tenir informés de toute avancée, difficulté, convocation ou changement de situation.<br/>
                                • communiquer de manière proactive, afin de permettre un accompagnement pertinent et efficace.<br/><br/>
                                L'équipe ne pourra être tenue responsable d'un défaut de suivi résultant d'un manque de communication ou de réactivité de la part du candidat.
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#2593C4', marginTop: '2rem', marginBottom: '1rem' }}>
                                💳 Tarif
                            </Typography>

                            <Typography paragraph style={{ backgroundColor: '#e7f3ff', padding: '1rem', borderRadius: '8px', marginBottom: '1.5rem' }}>
                                <strong>Forfait Expert – Olim avec parents</strong><br/>
                                👉 <strong style={{ fontSize: '1.1rem', color: '#2593C4' }}>2 000 ₪ TTC</strong><br/>
                                Le paiement est effectué au bénéfice de la société Raphael Madar – Tsahal Connection.<br/>
                                Le paiement permet à la fois l'accès à la prestation choisie et le soutien financier du projet Tsahal Connection dans sa globalité, afin de contribuer à sa continuité et à son développement.
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#dc3545', marginTop: '2rem', marginBottom: '1rem' }}>
                                ⚠️ Conditions de paiement – Non-remboursement
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1rem' }}>
                                Le paiement est requis avant le début de l'accompagnement.
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1rem' }}>
                                <strong>Tout paiement validé est définitif et non-remboursable, sans exception</strong>, notamment en cas de :<br/>
                                • changement de projet personnel.<br/>
                                • impossibilité de participer aux rendez-vous.<br/>
                                • décisions de Tsahal indépendantes de l'accompagnement.<br/>
                                • arrêt du suivi à l'initiative du candidat.
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1.5rem' }}>
                                Le candidat est responsable :<br/>
                                • de prendre ses rendez-vous avec l'équipe.<br/>
                                • d'informer suffisamment en amont de ses convocations officielles.<br/>
                                Aucun dédommagement ne pourra être exigé pour des prestations non utilisées du fait du candidat.
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#2593C4', marginTop: '2rem', marginBottom: '1rem' }}>
                                ➕ Clause complémentaire – Cas exceptionnels
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1rem' }}>
                                En cas de cessation d'activité, fermeture, dépôt de bilan de la société Raphael Madar – Tsahal Connection, OU en cas d'indisponibilité prolongée de l'équipe liée à des obligations militaires (période de réserve / miluim), lorsque ces obligations rendent impossible ou significativement entravent la bonne exécution des prestations prévues.
                            </Typography>

                            <Typography paragraph style={{ marginBottom: '1.5rem' }}>
                                Le candidat reconnaît expressément que, même dans ces cas exceptionnels, <strong>les sommes versées restent non remboursables</strong>, conformément aux conditions de paiement acceptées.
                            </Typography>

                            <Typography paragraph style={{ fontSize: '1rem', fontWeight: 'bold', color: '#28a745', marginTop: '2rem', marginBottom: '1rem' }}>
                                ✔️ Validation
                            </Typography>

                            <Typography paragraph style={{ backgroundColor: '#d4edda', padding: '1rem', borderRadius: '8px', borderLeft: '4px solid #28a745' }}>
                                En confirmant et en procédant au paiement, vous reconnaissez avoir pris connaissance des informations ci-dessus et acceptez l'intégralité des conditions de l'accompagnement.
                            </Typography>
                        </Box>
                    </Paper>

                    {/* Section Acceptation */}
                    <Paper elevation={2} style={{ 
                        padding: '1.5rem', 
                        marginTop: '2rem', 
                        marginBottom: '2rem',
                        backgroundColor: '#f8f9fa',
                        borderRadius: '12px'
                    }}>
                        <Box style={{ textAlign: 'center' }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={acceptedContract}
                                        onChange={(e) => setAcceptedContract(e.target.checked)}
                                        color="primary"
                                        sx={{ 
                                            '& .MuiSvgIcon-root': { 
                                                fontSize: { xs: 28, sm: 32 } 
                                            } 
                                        }}
                                    />
                                }
                                label={
                                    <Typography style={{ 
                                        fontFamily: 'Montserrat', 
                                        fontWeight: '500',
                                        fontSize: 'clamp(0.9rem, 2.5vw, 1.1rem)',
                                        lineHeight: '1.4',
                                        textAlign: 'left'
                                    }}>
                                        J'ai lu et j'accepte les termes et conditions de ce contrat de forfait expert
                                    </Typography>
                                }
                                sx={{
                                    alignItems: 'center',
                                    margin: 0,
                                    '& .MuiFormControlLabel-label': {
                                        paddingLeft: '8px'
                                    }
                                }}
                            />
                        </Box>
                    </Paper>

                    {/* Section Boutons */}
                    <Box style={{ 
                        display: 'flex', 
                        flexDirection: 'column',
                        gap: '1rem',
                        marginTop: '2rem',
                        paddingBottom: '2rem'
                    }}>
                        <Button
                            variant="contained"
                            size="large"
                            fullWidth
                            onClick={handleValidateContract}
                            disabled={!acceptedContract}
                            sx={{
                                backgroundColor: acceptedContract ? '#2593C4' : '#ccc',
                                color: 'white',
                                padding: { xs: '1rem 2rem', sm: '1.2rem 3rem' },
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                fontFamily: 'Montserrat',
                                fontWeight: '600',
                                borderRadius: '12px',
                                textTransform: 'none',
                                boxShadow: acceptedContract ? '0 4px 12px rgba(37, 147, 196, 0.3)' : 'none',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: acceptedContract ? '#1e7ba8' : '#ccc',
                                    transform: acceptedContract ? 'translateY(-2px)' : 'none',
                                    boxShadow: acceptedContract ? '0 6px 16px rgba(37, 147, 196, 0.4)' : 'none'
                                },
                                '&:disabled': {
                                    backgroundColor: '#ccc',
                                    color: '#999'
                                }
                            }}
                        >
                            Valider et Procéder au Paiement
                        </Button>
                        
                        <Button
                            variant="outlined"
                            size="large"
                            fullWidth
                            onClick={() => navigate('/expert-connection')}
                            sx={{
                                borderColor: '#2593C4',
                                color: '#2593C4',
                                padding: { xs: '1rem 2rem', sm: '1.2rem 3rem' },
                                fontSize: { xs: '1rem', sm: '1.1rem' },
                                fontFamily: 'Montserrat',
                                fontWeight: '600',
                                borderRadius: '12px',
                                textTransform: 'none',
                                borderWidth: '2px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: '#2593C4',
                                    color: 'white',
                                    transform: 'translateY(-1px)',
                                    borderWidth: '2px'
                                }
                            }}
                        >
                            ← Retour
                        </Button>
                    </Box>
                </Paper>
            </Container>



            <Footer />
        </div>
    );
};

export default ContratSuiviExpert;